import Reflux from "reflux";
export interface Listenable<F extends (...args: Array<any>) => any> {
	readonly listen: (callback: F) => () => void;
}
export interface ILazyStore {
	readonly disarm: () => void;
}
export type Subscription<F extends (...args: Array<any>) => any> = {
	readonly stop: () => void;
	readonly listenable: Listenable<F>;
};
export class Store {
	_store: any;
	_subscriptions: Subscription<any>[];

	constructor() {
		// @ts-expect-error
		this._store = Reflux.createStore();
		this._subscriptions = [];
	}

	listen(handler: () => void): () => void {
		return this._store.listen(handler);
	}

	listenTo<F extends (...args: Array<any>) => any>(listenable: Listenable<F>, callback: F): Subscription<F> {
		// listenTo binds to the store instance by default, but that's not very useful for us here, so bind to this
		const subscription = this._store.listenTo(listenable, callback.bind(this));

		if (subscription) {
			this._subscriptions.push(subscription);
		}

		return subscription;
	}

	unhook() {
		for (const subscription of this._subscriptions) {
			subscription.stop();
		}

		this._subscriptions = [];
	}

	trigger() {
		this._store.triggerAsync();
	}
}
export class LazyStore extends Store implements ILazyStore {
	/**
	 * @description onArm will be called when the store has to be active.
	 * Make sure to register all handlers and reinitialize all state in
	 * this handler.
	 */
	onArm: (() => void) | undefined;
	onDisarm: (() => void) | null | undefined;
	_listenerCount = 0;

	constructor() {
		super();
	}

	listen(handler: () => void): () => void {
		if (typeof this.onArm !== "function") {
			throw new Error("Do not use RelaxedStore without providing onArm!");
		}

		this._listenerCount++;

		if (this._listenerCount === 1) {
			this.onArm();
			// trigger, if we reconnect, so all depending stores can get
			// fresh data.
			this.trigger();
		}

		const unsubscribeReflux = super.listen(handler);
		return () => {
			unsubscribeReflux();
			this.disarm();
		};
	}

	disarm() {
		this._listenerCount--;

		if (this._listenerCount !== 0) {
			return;
		}

		if (typeof this.onDisarm === "function") {
			this.onDisarm();
		}

		this.unhook();
	}
}
